<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->

@if (modal$ | async; as modal) {
  @if (modal) {
    <div class="container-modal-list js-container-modal-list" (click)="close($event)">
      <modal-unit [modal]="modal"></modal-unit>
    </div>
  }
}
